import { kea } from 'kea'
import PropTypes from 'prop-types'

import entities from '~/entities'
import {find, get} from "lodash";
import {call, put} from "redux-saga/effects";
import {VideoAccesses} from "@gratify-eu/entities";

export default kea({
  key: (props) => {
    const {id, gfyPlugin} = props;

    return `${gfyPlugin}-${id}`
  },
  path: (key) => {
    return ['plugins', 'video-embed', key];
  },

  actions: ({ constants }) => ({
    loading: (videoAccessKey) => ({videoAccessKey}),
    loadSuccess: (videoAccess) => ({videoAccess}),
    loadFailed: true,
    trailerFinished: true,
    trailerRestarted: true,
    setActiveVideo: (videoIndex) => ({videoIndex})
  }),

  reducers: ({ actions, constants }) => ({
    loading: [false, PropTypes.bool, {
      [actions.loading]: () => true,
      [actions.loadSuccess]: () => false,
      [actions.loadFailed]: () => false,
    }],
    failed: [false, PropTypes.bool, {
      [actions.loadFailed]: () => true,
    }],
    trailerDone: [false, PropTypes.bool, {
      [actions.trailerFinished]: () => true,
      [actions.trailerRestarted]: () => false,
    }],
    activeIndex: [0, PropTypes.number, {
      [actions.setActiveVideo]: (_, payload) => {
        return payload.videoIndex || 0;
      }
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    videoAccess: [
      () => [
        entities.selectors.videoAccesses,
        (state, props) => props.videoAccessKey
      ], (videoAccesses, videoAccessKey) => {
        if (videoAccessKey) {
          const videoAccess = find(videoAccesses, {key: videoAccessKey});

          if (videoAccess) {
            return videoAccess;
          }
        }

        return null;
      },
      PropTypes.object
    ],

    videoPlayer: [
      () => [
        selectors.videoAccess,
      ], (videoAccess) => {
        if(videoAccess) {
          return videoAccess.video_player;
        }

        return null;
      },
      PropTypes.object
    ],

    productVideo: [
      () => [
        selectors.videoPlayer,
        (state, props) => (props),
      ], (videoPlayer, props) => {
        const { videoId } = props || {};
        if(videoPlayer && videoId) {
          return find(videoPlayer.videos, {id: videoId});
        }

        return null;
      },
      PropTypes.object
    ],

    hasAccess: [
      () => [
        selectors.videoPlayer,
      ], (videoPlayer) => {
        return videoPlayer && videoPlayer.has_access;
      },
      PropTypes.bool
    ],

    activeVideo: [
      () => [
        selectors.hasAccess,
        selectors.videoPlayer,
        selectors.activeIndex,
        selectors.productVideo,
      ], (hasAccess, videoPlayer, activeIndex, productVideo) => {
        if(productVideo) {
          return productVideo;
        }
        if(videoPlayer) {
          return videoPlayer.videos[activeIndex] || videoPlayer.videos[0]
        }

        return null;
      },
      PropTypes.object
    ],

    showPlaylist: [
      () => [
        selectors.videoPlayer,
        selectors.productVideo,
      ], (videoPlayer, productVideo) => {
        if(productVideo) {
          return false;
        }

        return videoPlayer && videoPlayer.videos && videoPlayer.videos.length > 1;
      },
      PropTypes.bool
    ],

    mainPoster: [
      () => [
        selectors.videoPlayer,
        selectors.productVideo,
      ], (videoPlayer, productVideo) => {
        if(productVideo && productVideo.thumbnail_image) {
          return productVideo.thumbnail_image;
        }

        if(videoPlayer && videoPlayer.main_poster_image) {
          return videoPlayer.main_poster_image;
        }

        return null;
      },
      PropTypes.string
    ],
    title: [
      () => [
        selectors.videoAccess,
        selectors.productVideo,
      ], (videoAccess, productVideo) => {
        if(productVideo && productVideo.name) {
          return productVideo.name;
        }

        if(videoAccess && videoAccess.name) {
          return videoAccess.name;
        }

        return null;
      },
      PropTypes.string
    ],
    description: [
      () => [
        selectors.videoAccess,
        selectors.productVideo,
      ], (videoAccess, productVideo) => {
        if(productVideo && productVideo.description) {
          return productVideo.description;
        }

        if(videoAccess && videoAccess.description) {
          return videoAccess.description;
        }

        return null;
      },
      PropTypes.string
    ],
  }),
  start: function* () {
    yield call(this.workers.fetchData);
  },
  workers: {
    fetchData: function* () {
      console.log('action creators', this.actionCreators);
      const { loading, loadSuccess, loadFailed } = this.actionCreators;
      const { videoAccessKey } = this.props;
      yield put(loading(videoAccessKey));
      console.log('loading', videoAccessKey);
      let result;
      try {
        result = yield call(VideoAccesses.workers.fetch, {payload: {id: videoAccessKey}}, true);


      } catch (e) {
        console.log('err', e);
        yield put(loadFailed())
      }
    },
  }
})
